import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { pdf } from "@react-pdf/renderer";
import * as XLSX from "xlsx";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AllPackingSlipsPdfDocument from "../PackageSlipPDF/AllPackingSlipsPdfDocument";
import PdfDocument from "../PDF/main";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Spinner,
  Card,
  ListGroup,
  Form,
  Table,
} from "react-bootstrap";

import "./View_DetailsLifecycle.css";
import {
  IconCalendarWeek,
  IconChevronDown,
  IconCopyCheck,
  IconEdit,
  IconMail,
  IconPhone,
  IconShare,
  IconUser,
  IconCopy,
  IconMapPin,
  IconPaperclip,
  IconCircleCheck,
  IconFileTypeDoc,
  IconChevronRight,
  IconFileTypePdf,
  IconPhoto,
  IconUserCircle,
  IconClockHour3,
  IconArrowForwardUp,
  IconRefreshDot,
  IconLink,
  IconReceipt,
  IconClipboardList,
  IconEye,
  IconTrash,
  IconCreditCardPay,
  IconFileTypeXls,
} from "@tabler/icons-react";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS, truncateFormat } from "../../../constant/_constant";
import { toast } from "react-toastify";
// import OrderKOorCustomerEmailDialog from "./Email/OrderKOorCustomerEmailDialog";
// import PackingSlipPdfDocument from '../PackageSlipPDF/Main'
import OrderKOorCustomerEmailDialog from "../Email/OrderKOorCustomerEmailDialog";
import moment from "moment";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";
import CopyLifeCycleFields from "../CopyLifeCycleFields";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import Logoquickbook from "../../../assets/QuickBooks_logo.png";
import feedIcons from "../../../assets/feed_icon.svg";
import SendMail from "../CustomerFeedbackEmail/SendMail";
import PackingSlipComponent from "../PackingSlip/PackingSlip";
import PackingSlipHistory from "../PackingSlip/PackingSlipHistory";
import { useSelector } from "react-redux";
import CardManagement from "../CardDetails/CardManagement";
import {
  shouldHideSubstatus,
  trimTrailingZeros,
} from "../../../utils/_helpers";
import PackingSlipPdfDocument from "../PackageSlipPDF/Main";
import PackingSlipEmail from "../Email/PackingSlipEmail";
import { usePostHog } from "@posthog/react";
import { generateWarehouseReport } from "../../../utils/generateWarehouseReport";
import axiosInstance from "../../../api/axiosInstance";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function View_DetailsLifecycle({
  //  show,
  //  setShow,
  //  order,
  isStatusUpdate,
  onStatusUpdate,
  triggerCardHighlight,
}) {
  const STATUS_TRANSITIONS = {
    PENDING: ["IN PROGRESS", "DELIVERED", "PAID_CLOSED", "LOST_CANCELLED"],
    "IN PROGRESS": ["PENDING", "DELIVERED", "PAID_CLOSED", "LOST_CANCELLED"],
    DELIVERED: ["PENDING", "PAID_CLOSED", "LOST_CANCELLED", "IN PROGRESS"],
    PAID_CLOSED: ["PENDING", "IN PROGRESS", "DELIVERED", "LOST_CANCELLED"],
    LOST_CANCELLED: [],
  };

  const statusOptions = [
    // { value: "DRAFT", label: "Payment Pending", color: "#6c757d" },
    { value: "PENDING", label: "Pending", color: "#f4a100" },
    { value: "IN PROGRESS", label: "In Progress", color: "#007bff" },
    // { value: "REACHED_WAREHOUSE", label: "At Warehouse", color: "#AE3EC9" },
    // { value: "SHIPPED", label: "Shipped", color: "#ae3ec9" },
    { value: "DELIVERED", label: "Shipped", color: "#42ad9fff" },
    { value: "PAID_CLOSED", label: "Paid & Closed", color: "#06a159ff" },
    { value: "LOST_CANCELLED", label: "Lost/Cancelled", color: "#D63939" },
  ];

  // const SUB_STATUS_TRANSITIONS = {
  //   PENDING: [
  //     "PO-Pending",
  //     "Pre-Payment-Pending"
  //   ],
  //   "PO-Pending": [
  //     "Pre-Payment-Pending"
  //   ],
  //   "Pre-Payment-Pending": [],
  //   "IN PROGRESS": [
  //     "In-Transit-to-Warehouse",
  //     "At-Warehouse",
  //     "Warehouse-Ready-to-Ship",
  //     "In-Transit-to-Customer"
  //   ],
  //   "In-Transit-to-Warehouse": [
  //     "At-Warehouse",
  //     "Warehouse-Ready-to-Ship",
  //     "In-Transit-to-Customer"
  //   ],
  //   "At-Warehouse": [
  //     "Warehouse-Ready-to-Ship",
  //     "In-Transit-to-Customer"
  //   ],
  //   "Warehouse-Ready-to-Ship": [
  //     "In-Transit-to-Customer"
  //   ],
  //   "In-Transit-to-Customer": [],
  //   DELIVERED: [
  //     "ARO",
  //     "Post-Payment-Pending",
  //     "Invoice-Payment-Pending"
  //   ],
  //   ARO: ["Post-Payment-Pending", "Invoice-Payment-Pending"],
  //   "Post-Payment-Pending": [
  //     "Invoice-Payment-Pending"
  //   ],
  //   "Invoice-Payment-Pending": []
  // }

  const SUB_STATUS_TRANSITIONS = {
    PENDING: ["PO-Pending", "Pre-Payment-Pending"],
    "PO-Pending": ["PENDING", "Pre-Payment-Pending"],
    "Pre-Payment-Pending": ["PENDING", "PO-Pending"],
    "IN PROGRESS": [
      "In-Transit-to-Warehouse",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
    ],
    "In-Transit-to-Warehouse": [
      "IN PROGRESS",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
    ],
    "At-Warehouse": [
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
      "In-Transit-to-Warehouse",
      "IN PROGRESS",
    ],
    "Warehouse-Ready-to-Ship": [
      "In-Transit-to-Customer",
      "In-Transit-to-Customer",
      "In-Transit-to-Warehouse",
      "IN PROGRESS",
    ],
    "In-Transit-to-Customer": [
      "In-Transit-to-Warehouse",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "IN PROGRESS",
    ],
    DELIVERED: ["ARO", "Post-Payment-Pending", "Invoice-Payment-Pending"],
    ARO: ["Post-Payment-Pending", "Invoice-Payment-Pending", "DELIVERED"],
    "Post-Payment-Pending": ["Invoice-Payment-Pending", "DELIVERED", "ARO"],
    "Invoice-Payment-Pending": ["DELIVERED", "ARO", "Post-Payment-Pending"],
    PAID_CLOSED: ["Vendor-Bill-Pending", "Vendor-Payment-Pending"],
    "Vendor-Bill-Pending": ["Vendor-Payment-Pending", "PAID_CLOSED"],
    "Vendor-Payment-Pending": ["Vendor-Bill-Pending", "PAID_CLOSED"],
  };

  const SUBSTATUS_OPTIONS = {
    PENDING: [
      { value: "PENDING", label: "Pending", color: "#f4a100" },
      { value: "PO-Pending", label: "PO Pending", color: "#f4a100" },
      {
        value: "Pre-Payment-Pending",
        label: "Pre-Payment Pending",
        color: "#f97316",
      },
    ],
    "IN PROGRESS": [
      { value: "IN PROGRESS", label: "In Progress", color: "#3b82f6" },
      {
        value: "In-Transit-to-Warehouse",
        label: "In Transit to Warehouse",
        color: "#3b82f6",
      },
      { value: "At-Warehouse", label: "At Warehouse", color: "#8b5cf6" },
      {
        value: "Warehouse-Ready-to-Ship",
        label: "Warehouse Ready to Ship",
        color: "#6366f1",
      },
      {
        value: "In-Transit-to-Customer",
        label: "Back Ordered / Partial Orders",
        color: "#0ea5e9",
      },
    ],
    DELIVERED: [
      { value: "DELIVERED", label: "Shipped", color: "#10b981" },
      { value: "ARO", label: "AR Closed", color: "#10b982" },
      {
        value: "Post-Payment-Pending",
        label: "Post-Payment Pending",
        color: "#10b981",
      },
      {
        value: "Invoice-Payment-Pending",
        label: "Invoice Payment Pending",
        color: "#14b8a6",
      },
    ],
    // PAID_CLOSED: [],
    PAID_CLOSED: [
      { value: "PAID_CLOSED", label: "Paid & Closed", color: "#06a159" },
      {
        value: "Vendor-Bill-Pending",
        label: "Vendor Bill Pending",
        color: "#06a159",
      },
      {
        value: "Vendor-Payment-Pending",
        label: "Vendor Payment Pending",
        color: "#06a159",
      },
    ],
    LOST_CANCELLED: [],
  };

  const getSubstatusLabel = (status, subStatus) => {
    const options = SUBSTATUS_OPTIONS[status] || [];
    const match = options.find((opt) => opt.value === subStatus);
    return match?.label || subStatus;
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const IMG = process.env.REACT_APP_BASE_URL_IMG;
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(statusOptions[0]);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [pendingStep, setPendingSteps] = useState([]);
  const [formId, setFormId] = useState(null);
  const [packageHistory, setPackageHistory] = useState([]);
  const [isSubstatusOpen, setIsSubstatusOpen] = useState(false);
  const [selectedSubstatus, setSelectedSubstatus] = useState(null);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const openCardDetails = () => setShowCardDetails(true);
  const closeCardDetails = () => setShowCardDetails(false);
  const posthog = usePostHog();

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    ORDERID: "",
    toEmail: "",
    toName: "",
  });

  const [isPackslipEmailOpen, setIsPackslipEmailOpen] = useState({});

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    order_id: "",
    btnText: "",
    label: "",
  });

  console.log("isPackslipEmailOpen", isPackslipEmailOpen);

  const [isPackageDetailsDialogOpen, setIsPackageDetailsDialogOpen] =
    useState(false);

  const [selectedPackingSlip, setSelectedPackingSlip] = useState(null);

  const [isPackageHistoryDialogOpen, setIsPackageHistoryDialogOpen] =
    useState(false);

  const [showCreateOrder, setShowCreateOrder] = useState(false);

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.ORDER_STATUS,
  );

  const { isLoading: isChangingSubstatus, postData: changeSubstatus } =
    usePostRequest(API_ENDPOINTS.ORDER_STATUS);

  const { data: syncedData, postData: syncData } = usePostRequest(
    API_ENDPOINTS.SYNC_QUICK_BOOK,
  );

  const { isLoading: createLoading, postData: createOrderCopy } =
    usePostRequest(API_ENDPOINTS.COPY_ORDER);

  const { data: fetcheddata, postData: GetPackigSlip } = usePostRequest(
    API_ENDPOINTS.GET_PACKING_SLIP,
  );

  const { data: fetchLink, postData: GetAttachment } = usePostRequest(
    API_ENDPOINTS.VIEW_ATTACHMENTS,
  );

  const { isLoading: deleteRecord, postData: DeleteRecord } = usePostRequest(
    API_ENDPOINTS.DELETE_PACKING_SLIP,
  );

  const { isLoading: isChangingStatus, postData: changeStatus } =
    usePostRequest(API_ENDPOINTS.CHANGE_STATUS_COC);

  const { isLoading: quickBookLoading, postData: SyncQuickBook } =
    usePostRequest(API_ENDPOINTS.SYNC_QUICK_BOOK);

  const { data: pendingSteps, postData: getSteps } = usePostRequest(
    API_ENDPOINTS.GET_PENDING_STEPS,
  );

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin", "business-development", "finance"];
  const canViewFinancials = user?.roles?.some((role) =>
    allowedRoles.includes(role),
  );

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    if (response.order_status === "PAID_CLOSED") {
      posthog.capture("order_moved_paid&closed", {
        moved_by: user?.email,
        order_id: response?.order_id,
      });
    }
    setShow({ isStatusUpdate: true });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    handleClose();
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const ChangeSubstatusHandler = (orderid, substatus) => {
    changeSubstatus(
      { order_id: orderid, order_status: substatus, is_next_clicked: false },
      (res) => {
        onStatusSuccess(res);
        triggerCardHighlight(orderid);
      },
      onStatusError,
    );
  };

  const ChangeStatusHandler = (orderid, status) => {
    statusChange(
      { order_id: orderid, order_status: status, is_next_clicked: false },
      // onStatusSuccess,
      (res) => {
        onStatusSuccess(res);
        console.log("triggerCardHighlight", orderid);
        triggerCardHighlight(orderid);
      },
      onStatusError,
    );
  };

  const onSyncSuccess = (response) => {
    toast.success(response.message);
    const orderId = window.location.search.slice(1);
    fetchOrder({ order_id: orderId, route_name: "view" });
  };

  const onChangeSuccess = (response) => {
    toast.success(response.message);
    const orderId = window.location.search.slice(1);
    fetchOrder({ order_id: orderId, route_name: "view" });
  };

  const onChangeError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const onSyncError = (error) => {
    toast.error(
      error.message || "An error occurred during syncing with Quickbooks.",
    );
  };

  const handleSync = (order) => {
    SyncQuickBook(
      {
        order_id: order?.order_id,
        order_payment_type: order?.order_payment_type,
      },
      onSyncSuccess,
      onSyncError,
    );
  };

  useEffect(() => {
    if (pendingSteps?.data) {
      setPendingSteps(pendingSteps?.data);
    }
  }, [pendingSteps]);

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async () => {
    // const OP_arr = String(`${row.order_id}`).split(".");
    const OP_arr = String(`order`).split(".");
    for (var i = 0; i < OP_arr?.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }
    const sanitizeAddress = (address) => {
      if (!address) return [];
      return address
        .split("\n") // split by newline
        .map((line) => line.replace(/\t+/g, " ").trim()) // replace tabs with space, trim
        .filter((line) => line.length > 0); // remove empty lines
    };
    const updatedInvoiceData = {
      // ...InvoiceData,
      invoice_num: String(order.order_id),
      Contract_Vehicle: order.ContractType?.name,
      KO_name: order.orderKo?.name,
      KO_email: order.orderKo.email,
      KO_phone: order.orderKo.phone,
      KO_address: sanitizeAddress(order.orderKo.address),
      Print_Date: String(today),
      trans_date: String(order.updated_at).split("T")[0],
      // due_date: row.due_date,
      estimated_date: order.estimated_date,
      Valid_For: order.valid_for,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: order.OrderProductSales,
      Tax: order.tax,
      Shipping_Cost: order.shipping_cost_sales,
      Total_Cost: order.total_cost_after_margin_sales,
      Other_Cost: order.total_other_cost_sales,
      BillTo_Phone: order.orderBilling.phone,
      BillTo_Name: order.orderBilling?.name,
      BillTo_Address: sanitizeAddress(order.orderBilling.address),
      BillTo_Email: order.orderBilling.email,
      // Notes: row.RfqNotes,
      Shipping_Details: {
        Organization_Name: order?.organization_name,
        KO_name: order.orderKo?.name,
        Sales_Head_Info: {
          Name: order.sales_lead_name, //formatStringKey
          Email: order.sales_lead_email,
          Phone: order.sales_lead_phone,
        },
        Customer_Name: order.orderShipping.name, // formatStringKey
        Customer_Email: order.orderShipping.email,
        Customer_Phone: order.orderShipping.phone,
        Customer_Address: sanitizeAddress(order.orderShipping.address),
        Shipping_Method: order.shipping_method,
        Shipping_Method_Detail: order.shipping_method_detail,
        Shipping_Terms: order.shipping_term,
        Estimated_Delivery: order.estimated_delivery,
        Payment_Terms: order.payment_term,
        Payment_Terms_Details: order.payment_term_detail,
      },
    };
    console.log("updatedInvoiceData", updatedInvoiceData);
    // setInvoiceData(updatedInvoiceData);
    //  Format Opportunity Name for file name
    let File_Opportunity_Name = "";

    File_Opportunity_Name = OP_arr.join(" ");

    setTimeout(async () => {
      // setLoading(true);
      const pdfBlob = await pdf(
        <PdfDocument invoicedata={updatedInvoiceData} />,
      ).toBlob();

      const url = URL.createObjectURL(pdfBlob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${File_Opportunity_Name} ${String(order.order_id).split(".")[0]
        }.pdf`;
      document.body.appendChild(a);
      console.log("2", a.download);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };

  const openModalPacking = (id) => {
    let modalMessage = "Are you sure you want to delete this record?";
    let modalTitle = "Delete Packing Slip Record";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let action = "delete";

    // ✅ bind the function to this id right away
    const handleDeleteRecord = () => {
      DeleteRecord({ packaging_slip_id: id }, onDeleteSuccess, onDeleteError);
      setIsModalOpen({ ...isModalOpen, show: false }); // close modal after delete
    };

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: handleDeleteRecord, // already bound to id
      title: modalTitle,
      icon: modalIcon,
      type,
    });
  };

  const openSubstatusModal = (Orderid, substatus, Old_Substatus) => {
    const displayStatus =
      substatus === "DELIVERED"
        ? "SHIPPED"
        : substatus === "ARO"
          ? "AR Closed"
          : substatus === "In-Transit-to-Customer"
            ? "Back Ordered / Partial Orders"
            : substatus;

    const displayOldStatus =
      Old_Substatus === "DELIVERED"
        ? "SHIPPED"
        : Old_Substatus === "ARO"
          ? "AR Closed"
          : Old_Substatus === "In-Transit-to-Customer"
            ? "Back Ordered / Partial Orders"
            : Old_Substatus;

    let modalMessage = `Are you sure you want to Change Substatus From "${displayOldStatus}" To "${displayStatus}"?`;
    let modalTitle = "Change Substatus";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeSubstatusHandler(Orderid, substatus);
    };
    let action = "Change";

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const openModal = (Orderid, status, Old_Status) => {
    const displayStatus =
      status === "DELIVERED"
        ? "SHIPPED"
        : status === "ARO"
          ? "AR Closed"
          : status === "In-Transit-to-Customer"
            ? "Back Ordered / Partial Orders"
            : status;

    const displayOldStatus =
      Old_Status === "DELIVERED"
        ? "SHIPPED"
        : Old_Status === "ARO"
          ? "AR Closed"
          : Old_Status === "In-Transit-to-Customer"
            ? "Back Ordered / Partial Orders"
            : Old_Status;

    // const displayStatus = status === "PENDING" ? "PO PENDING" : status;
    // const displayOldStatus =
    //   Old_Status === "PENDING" ? "PO PENDING" : Old_Status;
    let modalMessage = `Are you sure you want to Change Status From "${displayOldStatus}" To "${displayStatus}"?`;

    if (
      status.toLowerCase() === "shipped" ||
      status.toLowerCase() === "delivered" ||
      status.toLowerCase() === "in progress" ||
      status.toLowerCase() === "paid_closed"
    ) {
      getSteps(
        { order_id: Orderid, order_status: status },
        (response) => {
          const steps = response?.data || [];

          if (steps.length > 0) {
            const stepList = steps
              .map((step) => `<li class="list-group-item">${step.name}</li>`)
              .join("");

            modalMessage += `<br /><br />
            <span>
              Some Chain of Custody steps are incomplete. Do you want to mark them as completed and proceed?
              You can <a href="/aspettoportal/frontend/edit-order/${Orderid}" target="_blank" class="text-primary">Edit Order</a> from here.
            </span>
            <br/>
            <ul class="list-group mt-3">${stepList}</ul>`;
          }

          let modalTitle = "Change Status";
          let type = "success";
          let modalIcon = <IconRefreshDot stroke={1} />;
          let actionHandler = () => {
            ChangeStatusHandler(Orderid, status);
          };
          let action = "Change";

          setIsModalOpen({
            show: true,
            action,
            message: modalMessage,
            onConfirm: actionHandler,
            title: modalTitle,
            icon: modalIcon,
            type: type,
          });
        },
        (error) => {
          toast.error("Failed to fetch pending steps.");
        },
      );
      return; // Prevents falling through to the setIsModalOpen below
    }

    // Original modal logic outside the condition
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(Orderid, status);
    };
    let action = "Change";

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const CopyOrderHandler = (order) => {
    // console.log("order", order);
    const payload = {
      // attachment_id: formId,
      order_id: order?.order_id || null,
      // project_id: order?.project_id ? order?.project_id : null,
      // opportunity_name: opportunity?.opportunity_name || null,
      // initial_consolidation: Number(opportunity?.initial_consolidation || 0),
      // contract_type_id: Number(opportunity?.contract_type_id || 0),
      // published_date: moment().format("YYYY-MM-DD"),
      // sales_lead_username: opportunity?.sales_lead_username || null,
      // sales_lead_name: opportunity?.sales_lead_name || null,
      // sales_lead_email: opportunity?.sales_lead_email || null,
      // sales_lead_phone: opportunity?.sales_lead_phone || null,
      // organization_name: opportunity?.organization_name || null,
      // brief: opportunity?.brief || null,
      // estimated_delivery: opportunity?.estimated_delivery || null,
      // payment_term: opportunity?.payment_term || null,
      // shipping_method: opportunity?.shipping_method || null,
      // shipping_method_detail: opportunity?.shipping_method_detail || null,
      // shipping_term: opportunity?.shipping_term || null,
      // valid_for: opportunity?.valid_for || null,
      // is_draft: true,
      // shipping_cost: opportunity?.shipping_cost
      //   ? Number(opportunity.shipping_cost).toFixed(2)
      //   : "0.00",
      // tax: opportunity?.tax || "0.00",
      // ko_detail: {
      //   name: opportunity?.rfqKo?.name || null,
      //   email: opportunity?.rfqKo?.email || null,
      //   phone: opportunity?.rfqKo?.phone || null,
      //   address: opportunity?.rfqKo?.address || null,
      // },
      // shipping_detail: {
      //   name: opportunity?.rfqShipping?.name || null,
      //   email: opportunity?.rfqShipping?.email || null,
      //   phone: opportunity?.rfqShipping?.phone || null,
      //   address: opportunity?.rfqShipping?.address || null,
      // },
      // billing_detail: {
      //   name: opportunity?.rfqBilling?.name || null,
      //   email: opportunity?.rfqBilling?.email || null,
      //   phone: opportunity?.rfqBilling?.phone || null,
      //   address: opportunity?.rfqBilling?.address || null,
      // },
      // status: "DRAFT",
      // otherCost: Array.isArray(opportunity?.other_cost_json)
      //   ? opportunity.other_cost_json
      //   : JSON.parse(opportunity?.other_cost_json || "[]"),
      // products: (opportunity?.RfqProducts || []).map((product) => ({
      //   vendor_name: product.Vendor?.display_name || null,
      //   sku_id: product.sku_id,
      //   description: product.description || null,
      //   quantity: Number(product.quantity || 0),
      //   aspetto_price: Number(product.aspetto_price || 0),
      //   customer_price: Number(product.customer_price || 0),
      //   margin_percent: Number(product.margin_percent || 0),
      //   total_price: Number(product.total_price || 0),
      //   um: product.um || product.unit_of_measure || null,
      // })),
      // total_cost_before_margin: opportunity?.total_cost_before_margin
      //   ? Number(opportunity.total_cost_before_margin).toFixed(2)
      //   : null,
      // total_cost_after_margin: opportunity?.total_cost_after_margin
      //   ? Number(opportunity.total_cost_after_margin).toFixed(2)
      //   : null,
    };
    createOrderCopy(payload, onSuccess, onError);
  };

  const handleDownloadOrderExcel = async () => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.SINGLE_ORDER_EXPORT,
        { order_id: order?.order_id },
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Order_${order?.order_id}_${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed. Please try again.");
    }
  };

  const onSuccess = (res) => {
    setIsSuccsessModalOpen({
      show: true,
      title: "Order Created Successfully!",
      message: `Prepared by ${user?.username}. Order ID is ${res.order_id}. This Order is for ${res?.contract_type}.`,
      btntext: "Return Home",
    });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    handleClose();
  };

  const onError = (err) => {
    toast.error(err?.message || "Failed to duplicate Order.");
  };

  const openModalCopy = (order) => {
    let modalMessage = `Are you sure you want to duplicate this "${order?.order_id}" order?`;
    let modalTitle = "Duplicate Order";
    let type = "success";
    let modalIcon = <IconCopy stroke={1} />;
    const orderId = order?.order_id;
    let actionHandler = () => {
      // CopyOrderHandler(order);
      navigate("/create-order-lifecycle", { state: { orderId } });
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [order, setOrder] = useState(null);

  const [show, setShow] = useState(false);

  // console.log("order data", order);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");

  // console.log("rfqId from query params:", orderId);

  // console.log("Full URL:", window.location.href);
  // console.log("location.search:", window.location.search);

  const { data: fetchedOrder, postData: fetchOrder } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const orderId =
        searchParams.get("order_id") ||
        window.location.search.slice(1).split("&")[0];
      if (orderId) {
        fetchOrder({ order_id: orderId, route_name: "view" });
      }
    }
  }, [window.location.search]);
  // useEffect(() => {
  //   if (window.location.search) {
  //     const orderId = window.location.search.slice(1);
  //     // console.log("rfqId to be used:", orderId);
  //     fetchOrder({ order_id: orderId });
  //   }
  // }, [window.location.search]);

  useEffect(() => {
    if (fetchedOrder?.data) {
      setOrder(fetchedOrder.data); // Store fetched opportunity
      setShow(true);
    }
  }, [fetchedOrder]);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  useEffect(() => {
    if (order?.sub_status && order?.status) {
      const substatusOpts = SUBSTATUS_OPTIONS[order.status] || [];
      const match = substatusOpts.find((opt) => opt.value === order.sub_status);
      if (match) {
        setSelectedSubstatus(match);
      }
    }
  }, [order]);

  // useEffect(() => {
  //   const allowedStatuses = ["PENDING", "IN PROGRESS", "DELIVERED"];

  //   if (order && allowedStatuses.includes(order.status)) {
  //     syncData({
  //       order_id: order.order_id,
  //       order_payment_type: order.order_payment_type,
  //     });
  //   }
  // }, [order]);

  useEffect(() => {
    if (order?.status) {
      const match = statusOptions.find((opt) => opt.value === order.status);
      // console.log("match", match);
      if (match) {
        setSelected(match);
      }
    }
  }, [order]);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    // Optional: update status via API
  };

  const ITEMS_PER_VIEW = 3.5;

  const navigate = useNavigate();

  /*swiper*/

  /*swiper*/

  const handleCopy_Quote = (selectedOption, order_id) => {
    navigate("/copy-orderlifecycle", {
      state: {
        selectedCopy: selectedOption,
        orderCopy: order_id,
      },
    });
  };

  useEffect(() => {
    if (order) {
      GetPackigSlip({ order_id: order?.order_id });
    } else {
      return;
    }
  }, [order]);

  useEffect(() => {
    console.log("fetcheddata", fetcheddata);
    if (fetcheddata?.data) {
      setPackageHistory(fetcheddata.data);
    }
  }, [fetcheddata]);

  const onDeleteSuccess = (res) => {
    toast.success(res?.message || "Record deleted successfully");
    GetPackigSlip({ order_id: order?.order_id });
  };

  const onDeleteError = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const downloadImage = async (e, item) => {
    e.preventDefault();

    try {
      const res = await GetAttachment({ id: item?.id });

      const fileUrl = fetchLink?.data; // this is the returned URL
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = item?.original_name || "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // const downloadImage = async (e, item) => {
  //   e.preventDefault();

  //   const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
  //   const customFileName = item.original_name;

  //   try {
  //     const response = await fetch(imageUrl, {
  //       method: "GET",
  //     });

  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.setAttribute("download", customFileName || "download.jpg");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   }
  // };

  useEffect(() => {
    if (fetchLink?.data) {
      window.open(fetchLink.data, "_blank");
    }
  }, [fetchLink]);

  const viewAttachment = async (e, attachmentId) => {
    e.preventDefault();
    try {
      await GetAttachment({ id: attachmentId });
    } catch (error) {
      console.error("Failed to view attachment", error);
    }
  };

  const totalNotes = order?.section.reduce((acc, section) => {
    return acc + section.notes.length;
  }, 0);

  const handleShareClick = () => {
    const baseUrl = window.location.origin;
    // const fullUrl = `${baseUrl}/aspettoportal_dev/frontend/edit-order/${order?.order_id}`;
    const fullUrl = `${baseUrl}/list-order-lifecycle?${order?.order_id}`;

    // Check if the Clipboard API is available
    if (navigator.clipboard) {
      // Clipboard API is available, use it
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          console.log("Link copied to clipboard");
          toast.success("Link copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      // Fallback: Use a temporary textarea to copy text for browsers that do not support Clipboard API
      const textarea = document.createElement("textarea");
      textarea.value = fullUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast.success("Link copied to clipboard");
    }
  };

  const dueDates = order?.OrderChainOfCustodies.map((item) => item.due_date)
    .filter(Boolean)
    .map((date) => new Date(date));

  const minDueDate = dueDates?.length ? new Date(Math.min(...dueDates)) : null;
  const maxDueDate = dueDates?.length ? new Date(Math.max(...dueDates)) : null;

  const daysDifference =
    minDueDate && maxDueDate
      ? Math.ceil((maxDueDate - minDueDate) / (1000 * 60 * 60 * 24))
      : null;

  function getNextStepOrStatus(OrderChainOfCustodies) {
    if (
      !Array.isArray(OrderChainOfCustodies) ||
      OrderChainOfCustodies.length === 0
    ) {
      return "No steps available";
    }

    let lastCheckedIndex = -1;

    // Filter out deleted items first
    const validSteps = OrderChainOfCustodies.filter(
      (step) => step?.is_deleted !== true,
    );

    for (let i = 0; i < validSteps.length; i++) {
      if (validSteps[i]?.check_status) {
        lastCheckedIndex = i;
      }
    }

    if (lastCheckedIndex === validSteps.length - 1) {
      return "Completed";
    }

    const nextIndex = lastCheckedIndex + 1;
    if (validSteps[nextIndex]) {
      return validSteps[nextIndex].name;
    }

    return "No next step found";
  }

  const handleEditClick = () => {
    setShowCreateOrder(true);
  };

  // function getNextStepOrStatus(OrderChainOfCustodies) {
  //   if (
  //     !Array.isArray(OrderChainOfCustodies) ||
  //     OrderChainOfCustodies.length === 0
  //   ) {
  //     return "No steps available";
  //   }

  //   let lastCheckedIndex = -1;
  //   for (let i = 0; i < OrderChainOfCustodies.length; i++) {
  //     if (OrderChainOfCustodies[i]?.check_status) {
  //       lastCheckedIndex = i;
  //     }
  //   }

  //   if (lastCheckedIndex === OrderChainOfCustodies.length - 1) {
  //     return "Completed";
  //   }

  //   const nextIndex = lastCheckedIndex + 1;
  //   if (OrderChainOfCustodies[nextIndex]) {
  //     return OrderChainOfCustodies[nextIndex].name;
  //   }

  //   return "No next step found";
  // }

  const handleModalClose = () => {
    setShow({ show: false });
    navigate("/list-order-lifecycle");
  };

  const handleCheckboxChange = (id, status) => {
    const updatedStatus = status ? 0 : 1;
    changeStatus(
      {
        id: id,
        check_status: updatedStatus,
      },
      onChangeSuccess,
      onChangeError,
    );
  };

  const KoEmail = order?.orderKo?.email || "";

  const handlePreview = async (data) => {
    const pdfDoc = (
      <PackingSlipPdfDocument
        invoicedata={data}
        items={data.products}
        loggedInUser={user}
      />
    );

    const blob = await pdf(pdfDoc).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <>
      <CardManagement
        show={showCardDetails}
        onClose={closeCardDetails}
        orderId={order?.order_id}
        invoiceNum={order?.invoice_no}
        emailId={KoEmail}
        paymentAmount={order?.total_cost_after_margin_sales}
        transactionId={order?.transaction_id}
        onOtpVerified={() => {
          // ← add this
          const searchParams = new URLSearchParams(window.location.search);
          const orderId =
            searchParams.get("order_id") ||
            window.location.search.slice(1).split("&")[0];
          if (orderId) {
            fetchOrder({ order_id: orderId, route_name: "view" });
          }
        }}
      />
      <Offcanvas
        name="Detail"
        show={show}
        // onHide={handleClose}
        // onHide={() => setShow({ show: false })}
        onHide={handleClose}
        placement="end"
      >
        <SendMail
          show={showCreateOrder}
          onClose={() => setShowCreateOrder(false)}
          toEmail={order?.orderShipping?.email}
          orderId={order?.order_id}
        />
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="flex_profit_row">
              {canViewFinancials && (
                <>
                  <p className="mb-0">
                    <span className="profit_est">Est. Profit:</span> $
                    {(() => {
                      const after =
                        Number(order?.total_cost_after_margin_sales) || 0;
                      const before =
                        Number(order?.total_cost_before_margin_sales) || 0;
                      const profit = after - before;
                      const percentage =
                        after !== 0 ? (profit / after) * 100 : 0;
                      if (isNaN(profit) || isNaN(percentage)) {
                        return "N/A";
                      }
                      return `${truncateFormat(profit, 2)} (${truncateFormat(
                        percentage,
                        2,
                      )}%)`;
                    })()}
                  </p>
                  <p className="mb-0 mt-0">
                    <span className="profit_est">Est. Expenses:</span> $
                    {(() => {
                      const after =
                        Number(order?.total_cost_before_margin) || 0;
                      return truncateFormat(after, 2);
                    })()}
                  </p>
                </>
              )}
            </div>
            <div className="flex_profit_row">
              <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-disabled">Export Products</Tooltip>
              }
              >
                <span onClick={handleDownloadOrderExcel} style={{ cursor: "pointer" }}>
                  <IconFileTypeXls />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Generate PDF</Tooltip>}
              >
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    HandlePDFClick();
                  }}
                >
                  <IconFileTypePdf />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Packing Slip</Tooltip>}
              >
                <span
                  onClick={() => {
                    setIsPackageDetailsDialogOpen(true);
                    setSelectedPackingSlip(null);
                  }}
                >
                  <IconReceipt />
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-feedback">
                    {order?.feedback_token && order?.feedback_status === 1
                      ? "View Feedback"
                      : order?.feedback_token
                        ? "Feedback Link Already Generated"
                        : "Generate Feedback Link"}
                  </Tooltip>
                }
              >
                <span
                  onClick={() => {
                    if (order?.feedback_token && order?.feedback_status === 1) {
                      const reviewUrl = `/aspettoportal/frontend/list-customer-reviews?${order?.order_id}`;
                      window.open(reviewUrl, "_blank");
                    } else if (!order?.feedback_token) {
                      handleEditClick();
                    }
                  }}
                  style={{
                    cursor:
                      order?.feedback_token && order?.feedback_status === 1
                        ? "pointer"
                        : !order?.feedback_token
                          ? "pointer"
                          : "not-allowed",
                  }}
                >
                  <img src={feedIcons} alt="Feedback Icon" />
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Edit</Tooltip>}
              >
                <span
                  onClick={() => navigate(`/edit-order/${order?.order_id}`)}
                >
                  <IconEdit />
                </span>
              </OverlayTrigger>
              {/* {["pre-paid", "post-paid"].includes(
                order?.order_payment_type,
              ) && ( */}
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-disabled">
                    {" "}
                    {order?.transaction_id
                      ? "Payment Completed"
                      : "Card Payment"}
                  </Tooltip>
                }
              >
                {/* <span
                    onClick={
                      !order?.transaction_id
                        ? openCardDetails
                        : undefined
                    }
                    style={{
                      cursor:
                        order?.transaction_id
                          ? "not-allowed"
                          : "pointer",
                    }}
                  > */}
                <span
                  onClick={openCardDetails}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <IconCreditCardPay />
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Copy URL</Tooltip>}
              >
                <span onClick={handleShareClick}>
                  <IconShare />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Duplicate</Tooltip>}
              >
                <span
                  onClick={() => openModalCopy(order)}
                // onClick={() => {
                //   setIsCopyQuoteOpen({
                //     show: true,
                //     order_id: order?.order_id,
                //     btnText: "Copy Opportunity",
                //     label: "Opportunity",
                //   });
                // }}
                >
                  <IconCopyCheck />
                </span>
              </OverlayTrigger>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="head_title">
            <h2>Order ID: {order?.order_id}</h2>
            <div className="status_dropdown" style={{ position: "relative" }}>
              <label>Status</label>
              <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  backgroundColor: selected.color,
                }}
                disabled={order?.status === "LOST_CANCELLED"}
              >
                {selected.label} <IconChevronDown />
              </button>
              {isOpen && (
                <div className="status_dropdown_select">
                  {statusOptions
                    .filter((option) => {
                      const allowedStatuses =
                        STATUS_TRANSITIONS[order?.status || "DRAFT"];

                      // If order type is DS → remove REACHED_WAREHOUSE
                      if (order?.order_type === "DS") {
                        return (
                          allowedStatuses.includes(option.value) &&
                          option.value !== "REACHED_WAREHOUSE"
                        );
                      }

                      // Otherwise normal behavior
                      return allowedStatuses.includes(option.value);
                    })

                    // .filter((option) =>
                    //   STATUS_TRANSITIONS[order?.status || "DRAFT"].includes(
                    //     option.value
                    //   )
                    // )
                    // .filter((option) => option.value !== selected.value)
                    .map((option) => (
                      <div
                        className="status_options"
                        key={option.value}
                        onClick={() =>
                          openModal(order?.order_id, option.value, order.status)
                        }
                        style={{
                          backgroundColor: option.color + "20",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          option.color + "33")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          option.color + "20")
                        }
                      >
                        {option.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
            {SUBSTATUS_OPTIONS[order?.status]?.length > 0 && (
              <div className="status_dropdown" style={{ position: "relative" }}>
                <label className="text-sm">Stage Status</label>
                <button
                  onClick={() => setIsSubstatusOpen(!isSubstatusOpen)}
                  style={{
                    backgroundColor: selectedSubstatus?.color || "#6c757d",
                  }}
                  disabled={order?.status === "LOST_CANCELLED"}
                >
                  {/* {selectedSubstatus?.label || "Select Substatus"} <IconChevronDown /> */}
                  {getSubstatusLabel(order?.status, order?.sub_status) ||
                    "Select Substatus"}{" "}
                  <IconChevronDown />
                </button>
                {isSubstatusOpen && (
                  <div className="status_dropdown_select">
                    {SUBSTATUS_OPTIONS[order?.status]
                      // .filter((option) => option.value !== selectedSubstatus?.value)
                      .filter((option) => {
                        const allowedSubstatuses =
                          SUB_STATUS_TRANSITIONS[
                          order?.sub_status || order?.status
                          ] || [];

                        // return allowedSubstatuses.includes(option.value);
                        return (
                          allowedSubstatuses.includes(option.value) &&
                          !shouldHideSubstatus(order, option.value)
                        );
                      })
                      .map((option) => (
                        <div
                          className="status_options"
                          key={option.value}
                          onClick={() => {
                            openSubstatusModal(
                              order?.order_id,
                              option.value,
                              order.sub_status,
                            );
                            setIsSubstatusOpen(false);
                          }}
                          style={{
                            backgroundColor: option.color + "20",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "33")
                          }
                          onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "20")
                          }
                        >
                          {option.label}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
            {/* <div>
              {!(order?.feedback_token && order?.feedback_status === 1) && (
                <Button
                  style={{ minWidth: "auto" }}
                  variant="warning"
                  onClick={handleEditClick}
                  disabled={order?.feedback_token !== null}
                >
                  {order?.feedback_token ? "Feedback Link Generated" : "Generate Feedback Link"}
                </Button>
              )}
            </div> */}
          </div>
          <div className="head_mini_details">
            <div className="flex_profit_row life_rows">
              <div className="life_head">
                <p className="mb-0">
                  <b className="profit_est icon_life_next">
                    <IconArrowForwardUp stroke={1} />
                  </b>
                  <div>
                    <b className="profit_est">Up Next: </b>
                    <span className="d-block">
                      {getNextStepOrStatus(order?.OrderChainOfCustodies)}
                    </span>
                  </div>
                </p>
              </div>

              <div className="life_head">
                <p className="mb-0">
                  <b className="profit_est icon_life_next">
                    <IconCalendarWeek stroke={1} />
                  </b>
                  <div>
                    <p className="mb-0">
                      <b className="profit_est icon_life_next">
                        Est. Fulfilment Date:
                      </b>
                      {maxDueDate
                        ? moment(maxDueDate).format("MM/DD/YYYY")
                        : "N/A"}
                    </p>
                    <p className="mb-0">
                      <b className="profit_est">Est. Duration: </b>
                      {daysDifference !== null
                        ? `${daysDifference} day${daysDifference === 1 ? "" : "s"
                        }`
                        : "N/A"}
                    </p>
                  </div>
                </p>
              </div>
            </div>
            {/* <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Sales Lead:</b> <IconUser />{" "}
                {order.sales_lead_name || "N/A"}
              </p>
              <p className="mb-0">
                <IconMail /> {order.sales_lead_email || "N/A"}
              </p>
              <p className="mb-0">
                <IconPhone />
                {order.sales_lead_phone || "N/A"}
              </p>
            </div> */}
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Customer Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.organization_name || "N/A"}</b>
              </Col>{" "}
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> KO Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderKo.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderKo.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {order?.orderKo?.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Contracting Officer's",
                        toName: order?.orderKo?.name,
                        show: true,
                        ORDERID: order.order_id,
                        toEmail: order?.orderKo?.email,
                        Quote_No: order?.invoice_no,
                        defaultSubject: `${order?.invoice_no}----(LIFECYCLE)`,
                        skuData: order?.OrderProducts,
                        row: order,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{order?.orderKo.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderKo.address || "-"}</b>
              </Col>
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Ship To
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderShipping.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderShipping.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {order?.orderShipping?.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Customer Details",
                        toName: order?.orderShipping?.name,
                        show: true,
                        ORDERID: order.order_id,
                        toEmail: order?.orderShipping?.email,
                        Quote_No: order?.invoice_no,
                        defaultSubject: `${order?.invoice_no}----(LIFECYCLE)`,
                        skuData: order?.OrderProducts,
                        row: order,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{order?.orderShipping.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.orderShipping.address || "-"}</b>
              </Col>
            </Row>
          </div>

          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} /> Attachments{" "}
              <span>({order?.Attachments.length})</span>
            </p>
            <div className="carousel-container">
              {order?.Attachments && order?.Attachments.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {order.Attachments.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div
                                  className="attetch_info"
                                // onClick={(e) => {
                                //   downloadImage(e, item.file_name);
                                // }}
                                >
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <span
                                      className="text-blue"
                                      // href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Preview
                                    </span>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>

          <div className="tabs_details">
            <Tabs
              defaultActiveKey="General"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="General" title={`General`}>
                <div className="full_details border-0 p-0">
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      <p className="d-flex align-items-center gap-1">
                        Order Type:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>
                        {order?.order_type === "DS"
                          ? "Dropship"
                          : order?.order_type === "M"
                            ? "Manufacturing"
                            : order?.order_type === "CRK"
                              ? "Consolidate / Repack "
                              : order?.order_type === "KIT"
                                ? "Kit"
                                : order?.order_type === "S"
                                  ? "Stock"
                                  : "N/A"}
                      </b>
                    </Col>{" "}
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      <p className="d-flex align-items-center gap-1">
                        Contract Vehicle:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.ContractType.name || "N/A"}</b>
                    </Col>{" "}
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Order Payment Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.order_payment_type || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Customer Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.organization_name || "N/A"}</b>
                    </Col>
                  </Row>
                  {/* <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Valid For:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.valid_for || "N/A"} Days</b>
                    </Col>
                  </Row> */}
                  <Row className="flex_rows">
                    <Col lg={12} md={12}>
                      {" "}
                      <p>
                        <b className="d-block" style={{ color: "#000" }}>
                          Order Description:{" "}
                        </b>
                        {order?.brief || "N/A"}
                      </p>
                    </Col>{" "}
                  </Row>
                </div>
              </Tab>
              <Tab
                eventKey="Notes"
                title={
                  <>
                    Notes{" "}
                    <span className="badge bg-indigo-lt"> {totalNotes}</span>
                  </>
                }
              >
                {order?.section.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />{" "}
                    <p>No notes available</p>
                  </div>
                ) : (
                  order?.section.map((section) => (
                    <div key={section.id}>
                      {section.notes.length > 0 ? (
                        section.notes.map((note) => (
                          <Card
                            className="status_item_card w-100"
                            key={note.id}
                          >
                            <Card.Body>
                              <div className="flex_note_head mb-1">
                                <span className="badge bg-indigo-lt">
                                  {section.name.charAt(0).toUpperCase() +
                                    section.name.slice(1)}
                                  .
                                </span>
                                <div className="note_info_time">
                                  <p className="note_user mb-0">
                                    <IconUserCircle /> {note?.User?.first_name}{" "}
                                    {note?.User?.last_name}
                                  </p>
                                  {note.createdAt && (
                                    <p className="note_user mb-0">
                                      <IconClockHour3 />{" "}
                                      {moment(note.createdAt).format(
                                        "MM/DD/YYYY hh:mm A",
                                      )}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <p className="mb-0">{note.note}</p>
                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <div className="data_not_available text-center pb-4">
                          <Lottie animationData={notfoundData} />{" "}
                          <p>No notes available</p>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </Tab>
              <Tab
                eventKey="Products"
                title={
                  <>
                    Products{" "}
                    <span className="badge bg-indigo-lt">
                      {order?.OrderProducts.length}
                    </span>
                  </>
                }
              >
                {order?.order_type !== "DS" && (
                  <Button
                    className="mb-3"
                    onClick={() => generateWarehouseReport(order)}
                  >
                    Warehouse Report XLS
                  </Button>
                )}
                {order?.OrderProducts.map((product) => (
                  <div md={12} key={product.id}>
                    <Card className="status_item_card w-100">
                      <Card.Body>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Vendor Name</div>
                            <p className="label_card">
                              {product.Vendor?.display_name || "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">SKU ID</div>
                            <p className="label_card">
                              {product.sku_display_name || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Aspetto Cost</div>
                            <p className="label_card">
                              $
                              {product.aspetto_price
                                ? trimTrailingZeros(product.aspetto_price)
                                : "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">Total Cost</div>
                            <p className="label_card">
                              $
                              {product.total_price
                                ? product.total_price
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row mb-0">
                          <div className="rfq_item_card">
                            <div className="value_card">
                              Product Description
                            </div>
                            <p className="label_card mb-0">
                              {product.description ||
                                "No description available"}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Tab>
              {/* <Tab
                eventKey="Chain of Custody"
                title={
                  <>
                    Chain of Custody{" "}
                    <span className="badge bg-indigo-lt">
                      {
                        order?.OrderChainOfCustodies?.filter(
                          (item) => !item.is_deleted,
                        ).length
                      }
                    </span>
                  </>
                }
              >
                <Card>
                  <Card.Header className="d-flex align-items-center justify-content-between">
                    <h6 className="mb-0">
                      <b>
                        Sync data with{" "}
                        <img src={Logoquickbook} width={120} alt="" />
                      </b>
                    </h6>
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => handleSync(order)}
                      disabled={quickBookLoading}
                    >
                      {quickBookLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Sync"
                      )}
                    </button>
                  </Card.Header>
                  <Card.Body className="card-table table-responsive mail_wrapper border-0 mb-0">
                    <Table className="table-bordered">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Due date</th>
                          <th>Assignee</th>*/}
                          {/* <th>Status</th> */}
                        {/* </tr>
                      </thead>
                      <tbody>
                        {order?.OrderChainOfCustodies?.filter(
                          (chain) => !chain.is_deleted,
                        ).map((chain) => (
                          <tr key={chain.id}>
                            {/* <td>{chain.name || "N/A"}</td> */}
                            {/* <td> 
                              <Form.Check
                                type="checkbox"
                                label={chain.name || "N/A"}
                                checked={chain.check_status}
                                onChange={() =>
                                  handleCheckboxChange(
                                    chain.id,
                                    chain.check_status,
                                  )
                                }
                                className={
                                  chain.check_status
                                    ? "option-checked"
                                    : "fw-bold"
                                }
                              />
                            </td>
                            <td>{chain.due_date ? chain.due_date : "N/A"}</td>
                            <td>
                              {chain?.role_id === 0 &&
                                chain?.person_id === 0 ? (
                                "N/A"
                              ) : (
                                <>
                                  {chain?.role_id !== 0 && chain.Role?.name}{" "}
                                  {chain?.person_id !== 0 &&
                                    `${chain.User?.first_name} ${chain.User?.last_name}`}
                                </>
                              )}
                            </td>
                            {/* <td>
                              {chain.check_status ? (
                                <span className="check-icon" title="Checked">
                                  <IconCircleCheck stroke={1.25} />
                                </span>
                              ) : (
                                <></>
                              )}
                            </td> */}
                         {/* </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Tab> */}
              <Tab
                eventKey="Vendors"
                title={
                  <>
                    Vendors{" "}
                    <span className="badge bg-indigo-lt">
                      {order?.OrderVendors.length}
                    </span>
                  </>
                }
              >
                {order?.OrderVendors.map((vendor) => (
                  <div md={12} key={vendor.id}>
                    <Card className="status_item_card w-100">
                      <Card.Body>
                        <Row className="flex_rows">
                          <Col lg={12} md={12}>
                            <p className="d-flex align-items-center gap-1">
                              Vendor:
                              <b style={{ color: "var(--tblr-blue)" }}>
                                {vendor.Vendor
                                  ? vendor.Vendor.display_name
                                  : "N/A"}
                              </b>
                            </p>
                          </Col>
                        </Row>
                        {/* <Row className="flex_rows">
                            <Col lg={4} md={5}>
                              <p className="d-flex align-items-center gap-1">
                                Name:
                              </p>
                            </Col>
                            <Col lg={8} md={7}>
                              <b> {vendor.ko_name || "N/A"}</b>
                            </Col>
                          </Row> */}

                        <Row className="flex_rows">
                          <Col lg={2} md={5}>
                            <p className="d-flex align-items-center gap-1">
                              Email ID:
                            </p>
                          </Col>
                          <Col lg={10} md={7}>
                            <b>
                              {(() => {
                                const email =
                                  vendor?.Vendor?.VendorContact?.primary_email;
                                try {
                                  const parsed =
                                    typeof email === "string"
                                      ? JSON.parse(email)
                                      : email;
                                  return parsed?.Address || "N/A";
                                } catch {
                                  return email || "N/A";
                                }
                              })()}
                            </b>
                          </Col>
                        </Row>

                        <Row className="flex_rows">
                          <Col lg={2} md={5}>
                            <p className="d-flex align-items-center gap-1">
                              Phone:
                            </p>
                          </Col>
                          <Col lg={10} md={7}>
                            <b>
                              {(() => {
                                const phone =
                                  vendor?.Vendor?.VendorContact?.primary_phone;
                                try {
                                  const parsed =
                                    typeof phone === "string"
                                      ? JSON.parse(phone)
                                      : phone;
                                  return parsed?.FreeFormNumber || "N/A";
                                } catch {
                                  return phone || "N/A";
                                }
                              })()}
                            </b>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Tab>
              <Tab
                eventKey="Packing Slip History"
                title={
                  <>
                    Packing Slip History{" "}
                    <span className="badge bg-indigo-lt">
                      {packageHistory.length}
                    </span>
                  </>
                }
              >
                <Card>
                  <Card.Body className="card-table table-responsive mail_wrapper border-0 mb-0">
                    {/* {packageHistory?.length > 1 && (
                      <div className="mb-3 text-end">
                        <PDFDownloadLink
                          document={
                            <AllPackingSlipsPdfDocument
                              slips={packageHistory}
                              loggedInUser={user}
                            />
                          }
                          fileName={`All_PackingSlips_${order?.order_id}.pdf`}
                        >
                          {({ loading }) => (
                            <button className="btn btn-success">
                              {loading
                                ? "Preparing..."
                                : "Download All Packing Slips"}
                            </button>
                          )}
                        </PDFDownloadLink>
                      </div>
                    )} */}
                    <Table className="table-bordered">
                      <thead>
                        <tr>
                          <th>FROM ADDRESS</th>
                          <th>TO ADDRESS</th>
                          <th>SHIP DATE</th>
                          <th>VIEW</th>
                          <th>EMAIL</th>
                          <th>DELETE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!packageHistory || packageHistory.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No history found.
                            </td>
                          </tr>
                        ) : (
                          packageHistory.map((field) => (
                            <tr key={field.id}>
                              <td>{field.from_address}</td>
                              <td>{field.to_address}</td>
                              <td>
                                {moment(field.ship_date).format("MM-DD-YYYY")}
                              </td>
                              <td>
                                <IconEye
                                  style={{
                                    color: "var(--tblr-cyan)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    // setIsPackageDetailsDialogOpen(true);
                                    // setSelectedPackingSlip(field);
                                    handlePreview(field);
                                  }}
                                />
                              </td>
                              <td>
                                <IconMail
                                  style={{
                                    color: "var(--tblr-cyan)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setIsPackslipEmailOpen({
                                      show: true,
                                      order_id: field.Order?.order_id,
                                      slipdata: field,
                                      notifyEmails:
                                        order?.notification_emails || "",
                                      koEmail: order?.orderKo?.email,
                                      shippingEmail:
                                        order?.orderShipping?.email,
                                    });
                                  }}
                                />
                              </td>
                              <td>
                                <IconTrash
                                  style={{
                                    color: "var(--tblr-cyan)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => openModalPacking(field?.id)}
                                />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Tab>
            </Tabs>
          </div>
          {isEmaillOpen.show && (
            <OrderKOorCustomerEmailDialog
              pagetitle={isEmaillOpen.title}
              toEmail={isEmaillOpen.toEmail}
              toName={isEmaillOpen.toName}
              ORDERID={isEmaillOpen.ORDERID}
              show={isEmaillOpen.show}
              skuData={isEmaillOpen.skuData}
              row={isEmaillOpen.row}
              defaultSubject={isEmaillOpen.defaultSubject}
              Quote_No={isEmaillOpen.Quote_No}
              setShow={setIsEmaillOpen}
              setIsSuccsessModalOpen={setIsSuccsessModalOpen}
            />
          )}

          {isPackslipEmailOpen?.show && (
            <PackingSlipEmail
              show={isPackslipEmailOpen.show}
              setShow={setIsPackslipEmailOpen}
              order_id={isPackslipEmailOpen.order_id}
              slipData={isPackslipEmailOpen.slipdata}
              notifyEmails={isPackslipEmailOpen.notifyEmails}
              kEmail={KoEmail}
              shipEmail={isPackslipEmailOpen.shippingEmail}
              orgName={order?.organization_name}
              deliveryOrder={order?.orderExtra?.delivery_order}
              attachmnetid={order?.attachment_id}
              carrierType={order?.orderExtra?.carrier}
            />
          )}

          {isPackageHistoryDialogOpen && (
            <PackingSlipHistory
              orderId={order?.order_id}
              isPackageHistoryDialogOpen={isPackageHistoryDialogOpen}
              setIsPackageHistoryDialogOpen={setIsPackageHistoryDialogOpen}
            />
          )}

          {isPackageDetailsDialogOpen && (
            <PackingSlipComponent
              orderId={order?.order_id}
              isPackageDetailsDialogOpen={isPackageDetailsDialogOpen}
              setIsPackageDetailsDialogOpen={(open) => {
                setIsPackageDetailsDialogOpen(open);
                if (!open) {
                  setSelectedPackingSlip(null);
                }
              }}
              viewOnlyRecord={selectedPackingSlip}
              isViewMode={!!selectedPackingSlip}
            />
          )}

          {isCopyQuoteOpen.show && (
            <CopyLifeCycleFields
              module_id={isCopyQuoteOpen.order_id}
              show={isCopyQuoteOpen.show}
              onCopy={handleCopy_Quote}
              setShow={setIsCopyQuoteOpen}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          setIsOpen(false);
        }}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
    </>
  );
}

export default View_DetailsLifecycle;
